import React from 'react'

import { useSelector } from 'react-redux'

import Loading from '@components/UI/Loading'
import { useInfluencerIdentityId } from '@context/InfluencerIdentityId'
import { IApplicationState } from '@store'
import { selectIsFetchingSubmissionsByInfluencerIdentity } from '@store/submissions'
import InfluencerIdentityRowSubmissionList from '../List/List'
import { Wrapper } from './Wrapper.styled'

export const InfluencerIdentityRowSubmissionLoading = () => (
  <Wrapper justifyCenter alignCenter>
    <Loading height={30} />
  </Wrapper>
)

export const InfluencerIdentityRowSubmissionWrapper: React.FC = () => {
  const { contextInfluencerIdentityId } = useInfluencerIdentityId()
  const isFetching = useSelector((state: IApplicationState) =>
    selectIsFetchingSubmissionsByInfluencerIdentity(state, contextInfluencerIdentityId),
  )

  return isFetching ? (
    <InfluencerIdentityRowSubmissionLoading />
  ) : (
    <InfluencerIdentityRowSubmissionList />
  )
}

export default InfluencerIdentityRowSubmissionWrapper
